import { CART_MODULE } from "@/api_framework/api_config";
import { IHDCartItemAddPutResponse, IHDCartItemsAddPutBody } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setHDCartItemAdd } from "@/app_redux/reducers/slices/auth/cart_slice";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});

export const useCartItemAddAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (body: IHDCartItemsAddPutBody, cartType: "normal" | "hd") => {
      try {
        dispatch(
          setLoading({
            key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .put(`${CART_MODULE?.HD_CART_ITEM_ADD?.baseURL}`, body, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IHDCartItemAddPutResponse>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);
              dispatch(setHDCartItemAdd({ data: res.data.data }));
              dispatch(
                setLoading({
                  key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                  status: false,
                }),
              );
              return { status: true, message: null };
            } else {
              dispatch(setHDCartItemAdd({ data: null }));
              dispatch(
                setLoading({
                  key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                  status: false,
                }),
              );
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                status: false,
              }),
            );
            return { status: false, message: null };
          });
        return response;
      } catch (e) {
        dispatch(
          setLoading({
            key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
            status: false,
          }),
        );
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
